import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface PickingDelays1pDeliveryOrdersProps extends BaseTemplateProps {
  actionUrl: string
  orderCount?: string
}

export const PickingDelays1pDeliveryOrders: TemplateDefinition<PickingDelays1pDeliveryOrdersProps> =
  {
    renderParams: () => ({
      messageKey: 'notificationsDomain.templates.pickingDelays1pDeliveryOrders',
    }),
    getTitleParams: (props: PickingDelays1pDeliveryOrdersProps) => {
      if (!props?.orderCount) return undefined
      return {
        messageKey: 'notificationsDomain.templates.pickingDelays1pDeliveryOrders.title',
        values: { orderCount: parseInt(props.orderCount, 10) },
      }
    },
    getLink: (props: PickingDelays1pDeliveryOrdersProps): string => props?.actionUrl || '',
  }
